/**
 * 反馈工单 | 退款
 */
import Net from '../net';

const NAME = '[FeedbackApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Feedback === **/
/** ticket/overview
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function feedbackOverview(data = {}) {
  Log('feedbackOverview data:', data)
  try {
    const res = await Net.http('ticket/overview', { data })
    Log('feedbackOverview res:', res)
    return res
  } catch (err) {
    Log('feedbackOverview err:', err)
    throw err
  }
}

/** ticket/stat-progress
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.scene
 * @param {*} data.status
 * @param {*} data.progress
 * @param {*} data.operator_id
 * @param {*} data.card_uid
 * @param {*} data.charge_order_sn
 * @param {*} data.contract_phone
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function feedbackStatProgress(data = {}) {
  Log('feedbackStatProgress data:', data)
  try {
    const res = await Net.http('ticket/stat-progress', { data })
    Log('feedbackStatProgress res:', res)
    return res
  } catch (err) {
    Log('feedbackStatProgress err:', err)
    throw err
  }
}

/** ticket/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.sort
 * @param {*} data.uid
 * @param {*} data.scene
 * @param {*} data.status
 * @param {*} data.progress
 * @param {*} data.progress_list
 * @param {*} data.operator_id
 * @param {*} data.card_uid
 * @param {*} data.charge_order_sn
 * @param {*} data.contract_phone
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getFeedbackList(data = {}) {
  Log('getFeedbackList data:', data)
  try {
    const res = await Net.http('ticket/list', { data })
    Log('getFeedbackList res:', res)
    return res
  } catch (err) {
    Log('getFeedbackList err:', err)
    throw err
  }
}

/** ticket/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getFeedbackDetail(data = {}) {
  Log('getFeedbackDetail data:', data)
  try {
    const res = await Net.http('ticket/detail', { data })
    Log('getFeedbackDetail res:', res)
    return res
  } catch (err) {
    Log('getFeedbackDetail err:', err)
    throw err
  }
}

/** ticket/detail-by-uid
 * @param {Object} data
 * @param {*} data.uid
*/
export async function getFeedbackDetailByUid(data = {}) {
  Log('getFeedbackDetailByUid data:', data)
  try {
    const res = await Net.http('ticket/detail-by-uid', { data })
    Log('getFeedbackDetailByUid res:', res)
    return res
  } catch (err) {
    Log('getFeedbackDetailByUid err:', err)
    throw err
  }
}

/** ticket/comment
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.comment
*/
export async function commentFeedback(data = {}) {
  Log('commentFeedback data:', data)
  try {
    const res = await Net.http('ticket/comment', { data })
    Log('commentFeedback res:', res)
    return res
  } catch (err) {
    Log('commentFeedback err:', err)
    throw err
  }
}

/** ticket/action-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.id
 * @param {*} data.types
*/
export async function feedbackActionList(data = {}) {
  Log('feedbackActionList data:', data)
  try {
    const res = await Net.http('ticket/action-list', { data })
    Log('feedbackActionList res:', res)
    return res
  } catch (err) {
    Log('feedbackActionList err:', err)
    throw err
  }
}

/** ticket/process
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.remark
*/
export async function processFeedback(data = {}) {
  Log('processFeedback data:', data)
  try {
    const res = await Net.http('ticket/process', { data })
    Log('processFeedback res:', res)
    return res
  } catch (err) {
    Log('processFeedback err:', err)
    throw err
  }
}

/** ticket/update-remark
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.remark
*/
export async function updateFeedbackRemark(data = {}) {
  Log('updateFeedbackRemark data:', data)
  try {
    const res = await Net.http('ticket/update-remark', { data })
    Log('updateFeedbackRemark res:', res)
    return res
  } catch (err) {
    Log('updateFeedbackRemark err:', err)
    throw err
  }
}

/** ticket/close
 * @param {Object} data
 * @param {*} data.id
*/
export async function closeFeedback(data = {}) {
  Log('closeFeedback data:', data)
  try {
    const res = await Net.http('ticket/close', { data })
    Log('closeFeedback res:', res)
    return res
  } catch (err) {
    Log('closeFeedback err:', err)
    throw err
  }
}

/** order/query-charging-order
 * @param {Object} data
 * @param {*} data.card_uid
*/
export async function queryFeedbackChargingOrder(data = {}) {
  Log('queryFeedbackChargingOrder data:', data)
  try {
    const res = await Net.http('order/query-charging-order', { data })
    Log('queryFeedbackChargingOrder res:', res)
    return res
  } catch (err) {
    Log('queryFeedbackChargingOrder err:', err)
    throw err
  }
}

/** ticket/detail-by-card-uid
 * @param {Object} data
 * @param {*} data.card_uid
 * @param {*} data.card_type
*/
export async function getFeedbackDetailByCardUid(data = {}) {
  Log('getFeedbackDetailByCardUid data:', data)
  try {
    const res = await Net.http('ticket/detail-by-card-uid', { data })
    Log('getFeedbackDetailByCardUid res:', res)
    return res
  } catch (err) {
    Log('getFeedbackDetailByCardUid err:', err)
    throw err
  }
}

/** ticket/list-children
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.page
*/
export async function feedbackChildList(data = {}) {
  Log('feedbackChildList data:', data)
  try {
    const res = await Net.http('ticket/list-children', { data })
    Log('feedbackChildList res:', res)
    return res
  } catch (err) {
    Log('feedbackChildList err:', err)
    throw err
  }
}

/** order/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.ids
*/
export async function feedbackChargeOrderList(data = {}) {
  Log('feedbackChargeOrderList data:', data)
  try {
    const res = await Net.http('order/list', { data })
    Log('feedbackChargeOrderList res:', res)
    return res
  } catch (err) {
    Log('feedbackChargeOrderList err:', err)
    throw err
  }
}

/** insurance/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.order_ids
*/
export async function feedbackInsuranceOrderList(data = {}) {
  Log('feedbackInsuranceOrderList data:', data)
  try {
    const res = await Net.http('insurance/list', { data })
    Log('feedbackInsuranceOrderList res:', res)
    return res
  } catch (err) {
    Log('feedbackInsuranceOrderList err:', err)
    throw err
  }
}

/** ticket/detail-by-order-id
 * @param {Object} data
 * @param {*} data.order_id
*/
export async function getFeedbackDetailByOrderId(data = {}) {
  Log('getFeedbackDetailByOrderId data:', data)
  try {
    const res = await Net.http('ticket/detail-by-order-id', { data })
    Log('getFeedbackDetailByOrderId res:', res)
    return res
  } catch (err) {
    Log('getFeedbackDetailByOrderId err:', err)
    throw err
  }
}

/** ticket/query-uid-by-insurance-ids
 * @param {Object} data
 * @param {*} data.insurance_ids
*/
export async function getFeedbackDetailByInsuranceIds(data = {}) {
  Log('getFeedbackDetailByInsuranceIds data:', data)
  try {
    const res = await Net.http('ticket/query-uid-by-insurance-ids', { data })
    Log('getFeedbackDetailByInsuranceIds res:', res)
    return res
  } catch (err) {
    Log('getFeedbackDetailByInsuranceIds err:', err)
    throw err
  }
}


/** === Refund === **/
/** refund-record/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.id_name
 * @param {*} data.bank_card_id
 * @param {*} data.operator_id
 * @param {*} data.user_id
 * @param {*} data.status
 * @param {*} data.target_type
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getRefundList(data = {}) {
  Log('getRefundList data:', data)
  try {
    const res = await Net.http('refund-record/list', { data })
    Log('getRefundList res:', res)
    return res
  } catch (err) {
    Log('getRefundList err:', err)
    throw err
  }
}

/** refund-record/audit
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.status
 * @param {*} data.money
 * @param {*} data.fail_reason
*/
export async function refundAudit(data = {}) {
  Log('refundAudit data:', data)
  try {
    const res = await Net.http('refund-record/audit', { data })
    Log('refundAudit res:', res)
    return res
  } catch (err) {
    Log('refundAudit err:', err)
    throw err
  }
}

/** refund-record/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getRefundDetail(data = {}) {
  Log('getRefundDetail data:', data)
  try {
    const res = await Net.http('refund-record/detail', { data })
    Log('getRefundDetail res:', res)
    return res
  } catch (err) {
    Log('getRefundDetail err:', err)
    throw err
  }
}

/** refund-record/query-transfer-result
 * @param {Object} data
 * @param {*} data.id
*/
export async function updateRefund(data = {}) {
  Log('updateRefund data:', data)
  try {
    const res = await Net.http('refund-record/query-transfer-result', { data })
    Log('updateRefund res:', res)
    return res
  } catch (err) {
    Log('updateRefund err:', err)
    throw err
  }
}
